// @ts-nocheck
import * as React from "react"
import * as ReactDOM from "react-dom"

import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import "swiper/css/navigation";

import { ModalReviews } from './ModalReviews'

const THEMEURL = window.drupalSettings ? window.drupalSettings.path.themeUrl : 'themes/custom/mx_aguas_firmes_theme';

const container = document.querySelector('#modalRoot')

export default ({ data }: { data: SolutionSection }) => {
    const navigationPrevRef = React.useRef(null)
    const navigationNextRef = React.useRef(null)

    const [isVisbleModal, setIsVisbleModal] = React.useState<boolean>(false)
    const [videoId, setVideoId] = React.useState<string | null>(null)

    const getVideoID = (url: string) => {
        const match = url.match(/^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/);
        return (match && match[7].length==11) ? match[7] : false;
    }

    const openModal = (videoId: string) => {
        setVideoId(videoId)
        setIsVisbleModal(true)
    }

    return (
        <React.Fragment>

            <h2 className='solution__section-title' data-aos='fade-up'>{data.title}</h2>
            <div id="reviewCarousel" data-aos='fade-up'>
                <Swiper
                    modules={[Navigation]}
                    navigation={{
                        prevEl: navigationPrevRef.current,
                        nextEl: navigationNextRef.current,
                    }}
                    breakpoints={{
                        991: {
                            slidesPerView: 2
                        }
                    }}
                    onSwiper={(swiper) => {
                        // Delay execution for the refs to be defined
                        setTimeout(() => {
                            // Override prevEl & nextEl now that refs are defined
                            swiper.params.navigation.prevEl = navigationPrevRef.current
                            swiper.params.navigation.nextEl = navigationNextRef.current

                            // Re-init navigation
                            swiper.navigation.destroy()
                            swiper.navigation.init()
                            swiper.navigation.update()
                        })
                    }}
                >
                    {data.reviews.map((review: ESImage, indexReview: number) => (
                        <SwiperSlide key={indexReview}>
                            <div className="review">
                                {
                                    !review.video 
                                    ? <img className="review__icon" src={`/${THEMEURL}/sources/dist/assets/images/icons/cite.svg`} alt='Cita' title='Cita'/>
                                    : (<div className="review__video" onClick={() => openModal(getVideoID(review.video))}>
                                        <img src={`https://img.youtube.com/vi/${getVideoID(review.video)}/0.jpg`} alt={review.video} />
                                    </div>)
                                }
                                <h3 className="review__user">{review.username}</h3>
                                <h4 className="review__profession">{review.profession}</h4>
                                <div className="review__message" dangerouslySetInnerHTML={{ __html: review.message.replace(/\,\s?(\w+)_html$/gi, '') }}></div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
                <div ref={navigationPrevRef} className="swiper-button-prev" />
                <div ref={navigationNextRef} className="swiper-button-next" />
            </div>
            {isVisbleModal && ReactDOM.createPortal(<ModalReviews videoID={videoId} close={setIsVisbleModal} />, container)}
            
        </React.Fragment>
    )
}